import { useEffect, useState } from "react";
import Stepper from "../../Stepper/Stepper";
import { IUpdateLicense } from "../UpdateLicense/interface";
import './AddDevice.scss';
import { authorizationService } from "../../../api_services/authorizationService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../../Utils/Utils";
import DynamicTable from "../../DynamicTable/DynamicTable";
import FormBuilder from "../../../FormBuilder/FormBuilder";
import Loader from "../../Loader/Loader";
import { alertService } from "../../Services/alertService";

const AddDevice = (props: IUpdateLicense) => {
    const { onClose, onSubmit, data, type } = props;
    const [loader, setLoader] = useState<boolean>(true);
    const [selectedStep, setSelectedStep] = useState<number>(1);
    const [metaData, setMetaData] = useState<any>();
    const [rowsData, setRowsData] = useState<any>([]);
    const [step1Flag, setStep1Flag] = useState<boolean>(false);
    const [finalSubmit, setFinalSubmit] = useState<boolean>(false);
    const [inputFormData, setInputFormData] = useState<any>();
    const [requiredFieldData, setRequiredFieldData] = useState<any>();
    const [layout, setLayout] = useState<any>();
    const [tableData, setTableData] = useState<any>(
        {
        }
    );
    let payLoad: any = getURLDataMethod();
    const WeighDispenseStepperData = [
        {
            label: "General Info",
            value: "GeneralInfo",
        },
        {
            label: "Parameters",
            value: "Parameters",
        }
    ]
    useEffect(() => {
        if (type === "edit") {
            getEditMetaData(data);
        }
    }, [])

    useEffect(() => {
        if (type === "add") {
            getMetaData()
        }
    }, [type])

    // useEffect(() => {
    //     if (requiredFieldData) {
    //         insertDefaultValues(requiredFieldData, data);
    //     }
    // }, [requiredFieldData])

    const insertDefaultValues = (requiredFieldData: any, defaultData: any) => {
        for (var propt in defaultData) {
            // console.log(propt + ': ' + defaultData[propt]);
            const ind: any = requiredFieldData.findIndex((dataEle: any) => dataEle?.key === propt)
            if (ind > -1) {
                if (requiredFieldData[ind]?.defaultValue) {
                    requiredFieldData[ind]["defaultValue"] = defaultData[propt];
                    // requiredFieldData[ind]?.["defaultValue"] = defaultData[propt];
                }
                else {
                    requiredFieldData[ind]["defaultValue"] = defaultData[propt];
                }
            }
        }
        setRequiredFieldData(requiredFieldData);
    }

    const getMetaData = async () => {
        if (payLoad) {
            const payloadData = JSON.parse(JSON.stringify(payLoad));
            if (payloadData && payloadData['firmware_version']) {
                const device = payloadData['device_type']?.split('iLens-')[1];
                try {
                    return await authorizationService.getMetaData("MetaData", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLoader(true);
                                let response: any = res.body?.data;
                                setMetaData(response?.general_info);
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            console.log("error");
                            setLoader(false);
                        }
                    })
                } catch (err: any) {
                    setLoader(false);
                    console.log(err);
                }
            }
        }
    }

    const getEditMetaData = async (data: any) => {
        if (payLoad) {
            const payloadData = JSON.parse(JSON.stringify(payLoad));
            const deviceData = {
                "protocol": data?.protocol,
                "index": data?.index
            }
            payloadData["device"] = deviceData;
            // payloadData["device"]["protocol"]=data?.protocol;
            if (payloadData && payloadData['firmware_version']) {
                const device = payloadData['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.getEditMetaData("EditMetaData", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLoader(true);
                                let response: any = res.body?.data;
                                setMetaData(response?.general_info);
                                // setTableData(response?.parameters)
                                // setLayout(response?.layout)
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            console.log("error");
                            setLoader(false);
                        }
                    })
                } catch (err: any) {
                    setLoader(false);
                    console.log(err);
                }
            }
        }
    }

    const getTableData = () => {
        // 
    }

    const updateGetMetaData = async (editData?: any) => {
        if (payLoad) {
            const payloadData = JSON.parse(JSON.stringify(payLoad));
            if (editData) {
                const deviceData = {
                    "protocol": editData?.protocol,
                    "index": editData?.index
                }
                const redData = {
                    "general_info": inputFormData,
                    "parameters": rowsData,
                    "device": deviceData
                }
                payloadData["data"] = redData;
            }
            else {
                const redData = {
                    "general_info": inputFormData,
                    "parameters": rowsData
                }
                payloadData["data"] = redData;
            }
            if (payloadData && payloadData['firmware_version']) {
                const device = payloadData['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.updateDevice("UpdateDevice", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLoader(true);
                                onClose && onClose(false);
                                let response: any = res.body?.data;
                                alertService.serviceSuccessMessage(res?.body?.message)

                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            alertService.serviceErrorMessage(res?.response?.data?.message)
                            console.log("error");
                        }
                    })
                } catch (err: any) {
                    setLoader(false);
                    console.log(err);
                }
            }
        }
    }

    const addNewDevice = async () => {
        if (payLoad) {
            const payloadData = JSON.parse(JSON.stringify(payLoad));
            const reqData = {
                "general_info": inputFormData,
                "parameters": rowsData
            }
            payloadData["data"] = reqData;
            if (payloadData && payloadData['firmware_version']) {
                const device = payloadData['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.addDevice("AddDevice", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLoader(true);
                                let response: any = res.body?.data;
                                alertService.serviceSuccessMessage(res?.body?.message)
                                onClose && onClose(false)
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            alertService.serviceErrorMessage(res?.body?.message)
                            console.log("error");
                        }
                    })
                } catch (err: any) {
                    setLoader(false);
                    console.log(err);
                }
            }
        }
    }



    const onSave = () => {
        if (selectedStep === 1) {
            setFinalSubmit(true);
            setStep1Flag(true);
            if (validate(true)) {
                setSelectedStep(selectedStep + 1);
            }
        }
        else {
            setStep1Flag(true);
            if (validateTable()) {
                if (data) {
                    updateGetMetaData(data);
                }
                else {
                    // console.log('hello')
                    addNewDevice();
                }
            }
            else {
                alertService.serviceWarningMessage("Enter all required fields");
                // console.log(rowsData);
                // console.log(inputFormData);
            }

        }
    }

    const onCancel = () => {
        if (selectedStep === 1) {
            onClose && onClose(false)
        }
        else {
            setSelectedStep(selectedStep - 1);
        }
    }

    const validateNetworkFormData = () => {
        let valid = true;
        requiredFieldData?.forEach((item: any, index: number) => {
            if (inputFormData) {
                if (item?.required && item?.key) {
                    if (item?.key in inputFormData) {
                        if (!inputFormData[item?.key]) {
                            if (inputFormData[item?.key] === 0) {
                                // console.log(inputFormData[item?.key]);
                            }
                            else {
                                valid = false;
                            }
                        }
                        else {
                            // console.log(item?.key);
                        }

                    }
                    else {
                        valid = false;
                    }
                }
            }
            else {
                valid = false;
            }
        })
        return valid;
    }


    const getDynamicTableData = async (inputs: any, data?: any) => {
        if (payLoad) {
            const payloadData = JSON.parse(JSON.stringify(payLoad));
            const deviceData: any = {}
            if (data) {
                deviceData["protocol"] = data?.protocol;
                deviceData["index"] = data?.index;
                payloadData["device"] = deviceData;
                payloadData["inputs"] = inputs;
            }
            else if (inputs?.protocol) {
                deviceData["protocol"] = inputs?.protocol;
                payloadData["device"] = deviceData;
            }
            if (payloadData && payloadData['firmware_version']) {
                const device = payloadData['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.getDeviceParameter("GetDeviceParameter", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLoader(true);
                                let response: any = res.body?.data;
                                setTableData(response?.parameters)
                                setLayout(response?.layout)
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            console.log("error");
                            setLoader(false);
                        }
                    })
                } catch (err: any) {
                    setLoader(false);
                    console.log(err);
                }
            }
        }
    }


    // Validating the Input status
    const validate = (submitted: boolean) => {
        let isValid = true;
        if (validateNetworkFormData()) {
            if (type === "edit") {
                getDynamicTableData(inputFormData, data)
            }
            else {
                getDynamicTableData(inputFormData)
            }
        }
        else {
            isValid = false;
            alertService.serviceErrorMessage("Please fill all required fields");
        }
        return isValid;
    }

    const validateTable = () => {
        let isValid = true;
        if (finalSubmit && rowsData?.length > 0) {
            const refData: any = JSON.parse(JSON.stringify(rowsData));
            const receiveOddContainerInputs = JSON.parse(JSON.stringify(tableData?.bodyData))
            refData.forEach((x: any, index: number) => {
                receiveOddContainerInputs.forEach((y: any) => {
                    if (y.icon) {
                        // console.log(y.icon);
                    }
                    else {
                        if (typeof (refData[index][y.key]) === "boolean" && y?.required) {
                            if (refData[index][y.key] === false || refData[index][y.key] === true) {
                                // console.log(refData[index][y.key], y.key);
                            }
                            else {
                                isValid = false;
                            }

                        }
                        else if ((y?.required && !refData[index][y.key])) {
                            if (y?.disableDependency) {
                                if (refData[index][y.disableDependency] === false) {
                                    // console.log(refData[index][y.disableDependency])
                                }
                                else {
                                    isValid = false;
                                }
                            }
                            else if (refData[index][y.key] === 0) {
                                // console.log('1201', y?.key, refData[index][y.key])
                            }
                            else {
                                isValid = false;
                            }
                        }
                        else {
                            if (y?.disableDependency) {
                                // console.log(refData[index][y.disableDependency])
                            }
                            else {
                                // console.log(refData[index][y.key])
                            }
                        }
                    }
                })
            })
        }
        return isValid;
    }


    return (
        <>
            <div className="modal-body events-none" >
                <Stepper selectedStep={selectedStep} setSelectedStep={setSelectedStep} stepperData={WeighDispenseStepperData} stepperAlignmentClass="stepperAlignmentClass" />
                {loader && metaData ?
                    <fieldset>
                        <div>
                            {selectedStep === 1 && metaData?.length > 0 &&
                                <div>
                                    <>
                                        <FormBuilder
                                            config={metaData && metaData}
                                            finalSubmit={finalSubmit}
                                            // rowsAPI={rowsAPI}
                                            // setRowsAPI={setRowsAPI}
                                            setInputFormData={setInputFormData}
                                            setRequiredFieldData={setRequiredFieldData}
                                            requestedPage="addDevice"
                                            defaultValuesFromGet={data}
                                            singleDependency={true}
                                        />
                                    </>
                                </div>
                            }
                            {selectedStep === 2 &&
                                <>
                                    {inputFormData && tableData && Object.keys(tableData)?.length > 0 ?
                                        <div>
                                            <DynamicTable totalizerFlag={layout} rowsData={rowsData} setRowsData={setRowsData} tableData={tableData} dependantInputs={inputFormData} />
                                        </div>
                                        :
                                        <Loader hasError={false} />
                                    }
                                </>
                            }
                        </div>
                    </fieldset>
                    :
                    <Loader hasError={false} />
                }
            </div >
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={onCancel}>{selectedStep === 1 ? "Close" : "Go Back"}</button>
                    <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={onSave}>{selectedStep === 1 ? "Save and Proceed" : "Save"}</button>
                </div>
            </div>
        </>
    )
}
export default AddDevice;